export const primaryColor = "#0c61c6";
export const surfaceColor1 = "#c2deff";
export const surfaceColor2 = "#8cc1ff";
export const surfaceColor3 = "rgb(218 235 255)";
export const tuftsBlue = "#4680cf";
export const grey10 = "#f9f9f9";
export const linearTopGradient = "linear-gradient(to bottom, #6ca1cb, #317dd7)";
export const linearTopGradient2 = "linear-gradient(180deg, rgba(159,213,255,1) 39%, rgba(136,191,255,1) 100%);";
